/**
 * Normalise a bare `YYYY-MM-DD` date string into a Google-compliant
 * ISO 8601 datetime with IST timezone. Google Search Console flags
 * bare-date values in Article / VideoObject structured data as
 * "invalid datetime value" + "missing time zone" — this helper
 * short-circuits both warnings in one place.
 *
 * Behaviour:
 *   - If input already contains "T" (already a datetime), returned as-is.
 *   - If input is a bare "YYYY-MM-DD", pads with `T10:00:00+05:30`.
 *   - Falsy input returns undefined so schema builders can drop the key.
 *
 * IST (+05:30) chosen because Facetra is an India-native product; the
 * exact time is arbitrary — Google just needs a valid tz-aware value.
 */
export function normaliseSchemaDate(value) {
  if (!value) return undefined;
  if (typeof value !== "string") return value;
  if (value.includes("T")) return value;
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return `${value}T10:00:00+05:30`;
  return value;
}
